// 多重 hide() スケジューリングを防ぐためのフラグ。同じ element に対して
// 複数の hide() が走ると、display=none を解除する操作が後発の timer で
// 再度走り、メッセージが再表示されてしまう。
const hiding = new WeakSet();

window.flash = (message, status = 'success') => {
    const container = document.getElementById('flash-message');
    if (!container) return;
    container.innerHTML = '';
    const div = document.createElement('div');
    div.textContent = message;
    div.setAttribute('data-notification-status', status);
    div.classList.add('bar-top', 'notify', 'do-show');
    container.appendChild(div);
    setTimeout(hide, 33);
};

const hide = () => {
    const element = document.querySelector('.notify.do-show');
    if (!element) return;
    if (hiding.has(element)) return;
    hiding.add(element);
    const duration = element.classList.contains('long') ? 10000 : 2000;
    setTimeout(() => {
        // jQuery fadeOut('slow') 相当: opacity を CSS transition でフェード
        element.style.transition = 'opacity 0.4s';
        element.style.opacity = '0';
        setTimeout(() => {
            element.classList.remove('do-show');
            // CSS animation の forwards 解除後にメッセージが再表示されない
            // よう、jQuery fadeOut の最終状態 (display:none) を踏襲する。
            element.style.display = 'none';
        }, 400);
    }, duration);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hide);
} else {
    hide();
}
